import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import './i18n/config';
import './index.css';
import './index.scss';

import i18next from 'i18next';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { persistor, store } from './app/store';
import { ToastIcons } from './layout/dashboard.layout';
import PermissionAndPersist from './PermissionAndPersist';
import AuthProvider from './providers/AuthProvider';
import LocalStorageProvider from './providers/LocalStorageProvider';
import router from './routers/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <LocalStorageProvider>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <PermissionAndPersist persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
            {/* Toast container */}
            <ToastContainer
              position="top-right"
              hideProgressBar={false}
              newestOnTop={false}
              autoClose={10000}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              icon={<ToastIcons />}
            />
          </QueryClientProvider>
        </PermissionAndPersist>
      </Provider>
    </I18nextProvider>
  </LocalStorageProvider>
);
